module.exports = __webpack_public_path__ + "img/Alkhalil-white.5b2f3017.png";